export default __webpack_public_path__ + "static/media/background-loop-melodic-techno-04-3822.8e465237.mp3";